/* AgentProfileCardWrapper.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./AgentProfileCardWrapper.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  wrapper: "_1bsb1gwv"
};
export var AgentProfileCardWrapper = function AgentProfileCardWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.wrapper
  }, children);
};